import React from "react";

const TabIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.4">
      <path d="M7.78516 9.74732L9.49182 8.04065L7.78516 6.33398" fill="black" fillOpacity="0.45" />
      <path
        d="M7.78516 9.74732L9.49182 8.04065L7.78516 6.33398"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66602 8.04102H9.44602"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M8 2.66602C10.9467 2.66602 13.3333 4.66602 13.3333 7.99935C13.3333 11.3327 10.9467 13.3327 8 13.3327"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TabIcon;
